import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const QuoteMark = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="65"
      height="49"
      viewBox="0 0 65 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.3151 38.1377C26.3151 41.0957 25.1723 43.5158 22.8866 45.3982C20.7353 47.1461 17.8445 48.02 14.2143 48.02C10.7185 48.02 7.55883 46.3393 4.7353 42.978C1.91177 39.6167 0.5 35.2469 0.5 29.8688C0.5 24.4906 2.92017 18.978 7.7605 13.3309C12.6008 7.68388 19.9958 3.24691 29.9454 0.0200195L31.7605 4.45698C17.2395 11.0452 9.97899 19.9192 9.97899 31.0788C11.8613 29.062 14.1471 28.0536 16.8361 28.0536C19.5252 28.0536 21.7437 28.9948 23.4916 30.8772C25.374 32.7595 26.3151 35.1797 26.3151 38.1377ZM59.1891 38.1377C59.1891 41.0957 58.0462 43.5158 55.7605 45.3982C53.6093 47.1461 50.7185 48.02 47.0882 48.02C43.5924 48.02 40.4328 46.3393 37.6093 42.978C34.7857 39.6167 33.374 35.2469 33.374 29.8688C33.374 24.4906 35.7941 18.978 40.6345 13.3309C45.4748 7.68388 52.8698 3.24691 62.8193 0.0200195L64.6345 4.45698C50.1135 11.0452 42.8529 19.9192 42.8529 31.0788C44.7353 29.062 47.021 28.0536 49.7101 28.0536C52.3992 28.0536 54.6177 28.9948 56.3656 30.8772C58.2479 32.7595 59.1891 35.1797 59.1891 38.1377Z"
        fill="#242424"
      />
    </svg>
  </SVGIcon>
)

export default QuoteMark
